import React from 'react';

import { useCurrentBlockId } from '../../editor/EditorBlock';
import { setDocument, setSelectedBlockId } from '../../editor/EditorContext';
import EditorChildrenIds, { EditorChildrenChange } from '../helpers/EditorChildrenIds';

import { EMPTY_COLUMNS } from './columnsDefaults';
import ColumnsContainerLayout from './ColumnsContainerLayout';
import ColumnsContainerPropsSchema, { ColumnsContainerProps } from './ColumnsContainerPropsSchema';

export default function ColumnsContainerEditor({ style, props }: ColumnsContainerProps) {
  const currentBlockId = useCurrentBlockId();

  const { columns, ...restProps } = props ?? {};
  const columnsValue = columns ?? EMPTY_COLUMNS;

  const updateColumn = (
    columnIndex: 0 | 1 | 2 | 3,
    { block, blockId, childrenIds }: EditorChildrenChange
  ) => {
    const nColumns = [...columnsValue];
    nColumns[columnIndex] = { childrenIds };
    setDocument({
      [blockId]: block,
      [currentBlockId]: {
        type: 'ColumnsContainer',
        data: ColumnsContainerPropsSchema.parse({
          style,
          props: {
            ...restProps,
            columns: nColumns,
          },
        }),
      },
    });
    setSelectedBlockId(blockId);
  };

  return (
    <ColumnsContainerLayout
      style={style}
      props={restProps}
      columns={[
        <EditorChildrenIds
          key="col-0"
          childrenIds={columnsValue[0]?.childrenIds}
          onChange={(change) => updateColumn(0, change)}
        />,
        <EditorChildrenIds
          key="col-1"
          childrenIds={columnsValue[1]?.childrenIds}
          onChange={(change) => updateColumn(1, change)}
        />,
        <EditorChildrenIds
          key="col-2"
          childrenIds={columnsValue[2]?.childrenIds}
          onChange={(change) => updateColumn(2, change)}
        />,
        <EditorChildrenIds
          key="col-3"
          childrenIds={columnsValue[3]?.childrenIds}
          onChange={(change) => updateColumn(3, change)}
        />,
      ]}
    />
  );
}
